import { render, staticRenderFns } from "./TimelineSideBar.vue?vue&type=template&id=67bfd7c2&scoped=true&lang=pug"
import script from "./TimelineSideBar.vue?vue&type=script&lang=js"
export * from "./TimelineSideBar.vue?vue&type=script&lang=js"
import style0 from "./TimelineSideBar.vue?vue&type=style&index=0&id=67bfd7c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bfd7c2",
  null
  
)

export default component.exports